import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HomeIcon from '@mui/icons-material/Home';
import { UserContext } from 'context/User/UserContext';

/**
 * Wrapper component to check on privileges and roles to permit viewing
 * @param {number[]} privileges
 * @param {number[]} roles
 * @param {string} pageID
 * @param {any} props
 * @returns if permitted, returns the children
 */
const PrivilegedView = ({ privileges = [], roles = [], pageID, ...props }) => {
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const user =
		contextUser.userInfo.impersonationProfile ??
		contextUser.userInfo.userProfile;
	const canView =
		user?.Roles?.some(r => roles.includes(r.ID)) ||
		user?.Privileges?.some(p => privileges.includes(p.ID));
	const history = useHistory();

	return (
		<>
			{canView ? (
				props.children
			) : (
				<Card variant='outlined'>
					<CardContent>
						<Stack direction='row' alignItems='center' gap={1}>
							<ErrorOutlineIcon
								sx={{
									color: theme => theme.palette.error.dark,
								}}
							/>
							<Typography variant='h5' component='div'>
								Permission Denied
							</Typography>
						</Stack>
						<Stack
							direction='row'
							alignItems='center'
							gap={2}
							sx={{ mt: 1.5 }}
						>
							<Typography color='text.secondary'>
								Page Code: {pageID}
							</Typography>
						</Stack>
						<Typography variant='body2' sx={{ mt: 1.5 }}>
							You do not have the proper roles and/or privileges
							to view this page. If you believe this is in error,
							please contact{' '}
							<a href='mailto:imsreq@upmc.edu'>IMS Support</a>.
						</Typography>
					</CardContent>
					<CardActions>
						<Link
							underline='hover'
							color='text.secondary'
							onClick={() => history.push('/index.html')}
							sx={{ display: 'flex', alignItems: 'center' }}
						>
							<HomeIcon sx={{ mr: 0.5 }} fontSize='inherit' />
							Back to IMS Home
						</Link>
					</CardActions>
				</Card>
			)}
		</>
	);
};

export default PrivilegedView;
